import { CONST, fileTabVal } from "../../SideDrawer/sideTypes";
import { NavObjectType } from "../navigationTypes";

export const FIRMPROFILE = [ 'FirmName', 'FirmStreet1', 'FirmCity', 'FirmProvince', 'FirmPostalCode', 'FirmPhone', 'FirmEmail', 'FirmFax' ];
export const FIRMSESSION = [ 'name', 'address', 'city', 'province', 'postalcode', 'phone', 'email', 'fax' ];

namespace HOMECONST {
    export const defaultLeftDrawerState: Record<fileTabVal, NavObjectType> = {
        [fileTabVal.SUMMARY]:
        {
            label: "Summary",
            component: "main",
            url: "lfmaster.asp",
            params: {
                "tb": "TPAppXML",
                "formasp": "purfileedit",
                "id": CONST.uninitialized,
            },
            controller: {
                tabName: "Summary",
            },
            reactFrame: 'summary',
        },
        [fileTabVal.DETAILS]:
        {
            component: "main",
            url: "lfmaster.asp",
            params: {
                compat: "1",
                formasp: "purfileedit",
                id: CONST.uninitialized,
                tb: "TPAppXML",
            },
            controller: {
                tabName: "Basic",
                tabNumber: 0,
            },
            label: "Basic",
        },
        [fileTabVal.DOCUMENTS]: {
            component: "main",
            url: "lfmaster.asp",
            label: "All",
            params: {
                "tb": "TPAppXML",
                "formasp": "purfileedit",
                "id": CONST.uninitialized,
            },
            controller: {
                tabName: "Documents",
                autoClick: "documentListGroupingMethod2",
            },
        },
        [fileTabVal.CLIENTPORTAL]: {
            component: "main",
            url: "lfmaster.asp",
            params: {
                compat: "1",
                formasp: "purfileedit",
                id: CONST.uninitialized,
                tb: "TPAppXML",
                connectTab: 'true'
            },
            controller: {
                tabName: "Client Portal",
            },
            reactFrame: 'CLIENTPORTAL',
            label: "Client Intake Information",
        },
        [fileTabVal.NEWHOME]: {
            label: "Documents",
            component: "main",
            url: "lfmaster.asp",
            params: {
                "tb": "TPAppXML",
                "formasp": "purfileedit",
                "id": CONST.uninitialized,
                "PSM": CONST.uninitialized,
            },
            reactFrame: 'builderdoc',
            controller: {
                tabName: "NewHome",
            },
        },
        // should be unused
        [fileTabVal.WORKSPACE]: undefined,
        [fileTabVal.EMPTY]: undefined,
    };
}

export default HOMECONST;